import { Grid, IconButton, Tooltip } from '@material-ui/core'
import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { metodoPrograma } from '../../../components/api'
import Programa from '../../../components/Programa/Programa'
import Table from '../../../components/Table'
import Edicao from './Edicao'

const ProgramaControle = () => {
  const [lista, setLista] = useState([])

  const buscaLista = useCallback(async () => {
    const res = await metodoPrograma('lista')
    setLista(res.lista || [])
  }, [])

  useEffect(() => {
    buscaLista()
  }, [buscaLista])

  // const exclui = idUsuario => async e => {
  //   e.stopPropagation();
  //   if (!window.confirm('Mas você tem CERTEZA que deseja excluir este usuário???')) return;
  //   await metodoPrograma('exclui', { idUsuario });
  //   await buscaLista();
  // };

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [programaAberto, setProgramaAberto] = useState([])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar Programa">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const voltar = () => {
    buscaLista()
    setTela('lista')
  }

  const handleClick = (_, linha) => {
    setProgramaAberto(linha)
    setTela('opcoes')
  }
  return (
    <Programa codigo="Programa" ferramentas={ferramentas}>
      <Grid container spacing={2}>
        {tela === 'lista' ? (
          <Table
            dados={lista}
            head={[
              'ID',
              'ID Pai',
              'Título',
              'Link',
              'Ícone',
              'Ordenação',
              'Situação',
            ]}
            line={(l) => [
              l[0],
              l[1]?.[1],
              l[2],
              l[4],
              l[5],
              l[7],
              l[8] ? 'Ativo' : 'Inativo',
            ]}
            columnOptions={[
              {
                alias: 4,
                customJsx: ({ linhaOriginal }) => (
                  <IconButton size="small">
                    <i className={linhaOriginal[5]} />
                  </IconButton>
                ),
              },
            ]}
            onClick={handleClick}
          />
        ) : (
          <Edicao {...{ programaAberto, voltar }} />
        )}
      </Grid>
    </Programa>
  )
}

export default memo(ProgramaControle, isEqual)
